export const SMART_CONTRACT_PLUGIN_IDS = {
    SMART_CONTRACT_INPUT: "SMART_CONTRACT_INPUT",
    SMART_CONTRACT_OUTPUT: "SMART_CONTRACT_OUTPUT",
    SMART_CONTRACT_ASSIGN: "SMART_CONTRACT_ASSIGN",
    SMART_CONTRACT_DECLARE: "SMART_CONTRACT_DECLARE",
    SMART_CONTRACT_FUNCTION_CALL: "SMART_CONTRACT_FUNCTION_CALL",
    SMART_CONTRACT_EXPRESSION: "SMART_CONTRACT_EXPRESSION",
    SMART_CONTRACT_IF: "SMART_CONTRACT_IF",
    SMART_CONTRACT_DO_WHILE: "SMART_CONTRACT_DO_WHILE",
    SMART_CONTRACT_WHILE: "SMART_CONTRACT_WHILE",
    SMART_CONTRACT_FOR: "SMART_CONTRACT_FOR",
    SMART_CONTRACT_EMIT_EVENT: "SMART_CONTRACT_EMIT_EVENT"
};

export const SMART_CONTRACT_TYPES = {
    SMART_CONTRACT_ASSIGN: "ASSIGN",
    SMART_CONTRACT_DECLARE: "DECLARE",
    SMART_CONTRACT_FUNCTION_CALL: "FUNCTION_CALL",
    SMART_CONTRACT_EXPRESSION: "CUSTOM",
    SMART_CONTRACT_IF: "IF",
    SMART_CONTRACT_DO_WHILE: "DO",
    SMART_CONTRACT_WHILE: "WHILE",
    SMART_CONTRACT_FOR: "FOR",
    SMART_CONTRACT_DELIMITATOR: "DELIMITATOR",
    SMART_CONTRACT_EMIT_EVENT: "EVENT_EMIT",
    GENERAL_START_PLUGIN: "GENERAL_START_PLUGIN",
    GENERAL_END_PLUGIN: "GENERAL_END_PLUGIN"
};
